import React from 'react';
import { Hero } from '../components/Hero';
import { LocalTrust } from '../components/LocalTrust';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
export function Home() {
  return <main data-id="element-1482">
      <Hero data-id="element-1483" />
      <LocalTrust data-id="element-1484" />
      <Services data-id="element-1485" />
      <HowItWorks data-id="element-1486" />
      <FAQ data-id="element-1487" />
      <Reviews data-id="element-1488" />
    </main>;
}